// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"f61819ac","185":"65a60575","471":"152c5c31","632":"7351a907"}[chunkId] + ".chunk.js";
};